// removed by extract-text-webpack-plugin
module.exports = {"external-wrapper":"SubNav__external-wrapper___3tCL0","navbar":"SubNav__navbar___3q7hB","navbar-collapsed":"SubNav__navbar-collapsed___1KAA2 SubNav__navbar___3q7hB","wrapper":"SubNav__wrapper___2-qr0","sub-nav-overflow":"SubNav__sub-nav-overflow___GihIB","sub-nav-wrapper":"SubNav__sub-nav-wrapper___2KMYs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SubNav.scss
// module id = 520
// module chunks = 0